module.exports = __webpack_public_path__ + "static/img/08.19697e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/08.jpg
// module id = LSBy
// module chunks = 0